import { defineMessages } from 'react-intl';

const messages = defineMessages({
  insufficientStock: {
    description: 'Rejection reason drop down option for not enough stock available',
    defaultMessage: 'Insufficient Stock',
    id: 'kJE9A5',
  },
  unknownSku: {
    description:
      'Rejection reason drop down option for not an unknown SKU (Stock Keeping Unit. A retailer typically uses SKUs to identify their business’s inventory)',
    defaultMessage: 'Unknown SKU',
    id: 'ZmBvEO',
  },
  addressNotSupported: {
    description: 'Rejection reason drop down option for Delivery address not supported',
    defaultMessage: 'Delivery address not supported',
    id: 'f2vxNz',
  },
  other: {
    description: 'Rejection reason drop down option for Other',
    defaultMessage: 'Other',
    id: 'GgJGOK',
  },
});

export const RejectionReasonEnum = {
  insufficientStock: {
    value: 'Insufficient Stock',
    messageDescriptor: messages.insufficientStock,
  },
  unknownSku: {
    value: 'Unknown SKU',
    messageDescriptor: messages.unknownSku,
  },
  addressNotSupported: {
    value: 'Delivery address not supported',
    messageDescriptor: messages.addressNotSupported,
  },
  other: {
    value: 'Other',
    messageDescriptor: messages.other,
  },
};
